import type {
	FetchUiModificationsAction,
	FetchUiModificationsSuccess,
	FetchUiModificationsFailure,
	RestUiModificationsData,
} from 'state/actions/ui-modifications';
import {
	FETCH_UI_MODIFICATIONS_SUCCESS,
	FETCH_UI_MODIFICATIONS_FAILURE,
} from 'state/actions/ui-modifications';

export interface UiModificationsEntry {
	data?: RestUiModificationsData;
	error?: string;
}

export interface UiModificationsState {
	[key: string]: UiModificationsEntry | undefined;
}

export type HandledActions =
	| FetchUiModificationsAction
	| FetchUiModificationsSuccess
	| FetchUiModificationsFailure;

const buildStoreKey = (portalId: number, requestTypeId: number) => `${portalId}/${requestTypeId}`;

const defaultState: UiModificationsState = {};

export function uiModificationsReducer(
	state: UiModificationsState = defaultState,
	action: HandledActions,
): UiModificationsState {
	switch (action.type) {
		case FETCH_UI_MODIFICATIONS_SUCCESS: {
			const { portalId, requestTypeId, uiModifications } = action.payload;
			const storeKey = buildStoreKey(portalId, requestTypeId);

			return {
				[storeKey]: {
					data: uiModifications,
					error: undefined,
				},
			};
		}

		case FETCH_UI_MODIFICATIONS_FAILURE: {
			const { portalId, requestTypeId, error } = action.payload;
			const storeKey = buildStoreKey(portalId, requestTypeId);

			return {
				[storeKey]: {
					data: undefined,
					error: error.errorMessages?.[0] ?? 'Failed to fetch UI modifications',
				},
			};
		}

		default:
			return state;
	}
}
